/**
 * @generated SignedSource<<f0c2460d5c39ab0e4fb708c1bd7ff88e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cmsSpecialtyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityLocationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfBeds"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "cmsSpecialtyId",
        "variableName": "cmsSpecialtyId"
      },
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "facilityLocationId",
        "variableName": "facilityLocationId"
      },
      {
        "kind": "Variable",
        "name": "numberOfBeds",
        "variableName": "numberOfBeds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewFacilityLocationCmsSpecialtyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationCmsSpecialtyModifyPayload",
            "kind": "LinkedField",
            "name": "createCmsSpecialty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "facilityLocationCmsSpecialty",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationCmsSpecialty",
                        "kind": "LinkedField",
                        "name": "cmsSpecialties",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FacilityLocationCmsSpecialties_CmsSpecialties"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewFacilityLocationCmsSpecialtyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FacilityLocationMutationGroup",
        "kind": "LinkedField",
        "name": "facilityLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FacilityLocationCmsSpecialtyModifyPayload",
            "kind": "LinkedField",
            "name": "createCmsSpecialty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FacilityLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "facilityLocationCmsSpecialty",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacilityLocation",
                    "kind": "LinkedField",
                    "name": "facilityLocation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityLocationCmsSpecialty",
                        "kind": "LinkedField",
                        "name": "cmsSpecialties",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CmsSpecialty",
                            "kind": "LinkedField",
                            "name": "cmsSpecialty",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "code",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CmsSpecialtyVersion",
                                "kind": "LinkedField",
                                "name": "applicableVersion",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numberOfBeds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b6401b92568bd1871913fb2cfeb8eb1",
    "id": null,
    "metadata": {},
    "name": "NewFacilityLocationCmsSpecialtyModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewFacilityLocationCmsSpecialtyModalMutation(\n  $facilityLocationId: ID!\n  $cmsSpecialtyId: ID!\n  $numberOfBeds: Int\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facilityLocation {\n    createCmsSpecialty(input: {facilityLocationId: $facilityLocationId, cmsSpecialtyId: $cmsSpecialtyId, numberOfBeds: $numberOfBeds, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityLocationCmsSpecialty {\n        id\n        facilityLocation {\n          cmsSpecialties {\n            ...FacilityLocationCmsSpecialties_CmsSpecialties\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FacilityLocationCmsSpecialties_CmsSpecialties on FacilityLocationCmsSpecialty {\n  id\n  cmsSpecialty {\n    id\n    code\n    applicableVersion {\n      name\n      id\n    }\n  }\n  numberOfBeds\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "b65e9c1db8483c306af41da3851fe130";

export default node;
